import { enumXMLType } from "../constants";
import { XML_FillRect } from "./XML_FillRect";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_AddPair } from "./XML_AddPair";

export function XML_DrawBackground(
  x,
  y,
  width,
  height,
  bkgroundColor,
  bkgroundColor2,
  xmlCanvas,
  layer
) {
  var docType = xmlCanvas.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_FillRect(x, y, width, height, bkgroundColor, bkgroundColor2, xmlCanvas, layer);
  else {
    if (bkgroundColor2 != null) XML_AddPair(bkgroundColor, bkgroundColor2, "bk", xmlCanvas);
    else XML_AddSingle(bkgroundColor, "bk", xmlCanvas);
  }
}
